export enum AdPlacement {
    TOP_BANNER = 'top_banner',
    LAYER = 'layer'
}
